export default {
      id: "reddit-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#reddit",
      toString: function () {
        return this.url;
      }
    }